import { useMemo } from "react";

import { firebase } from "astrid-firebase";
import getWorksQuery from "astrid-firestore/src/api/works/getWorksQuery";
import useCollectionData from "astrid-firestore/src/hooks/useCollectionData";

import sortWorks from "../utils/sortWorks";

export default function useWorks(options) {
	const [works, loading, error] = useCollectionData(getWorksQuery(firebase, options));

	const sortedWorks = useMemo(() => sortWorks(works), [works]);

	return [sortedWorks, loading, error];
}
